import PropTypes from 'prop-types';

const data = PropTypes.shape({
  embeddable: PropTypes.bool,
  callId: PropTypes.string,
  startTimestamp: PropTypes.string,
  endTimestamp: PropTypes.string,
  caption: PropTypes.string,
});

export const IGongProps = {
  data,
};
